const BlankoPage = () => {
	return (
		<h1>Blankos</h1>
	);
}

export default BlankoPage;